import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center", padding: "100px 20px", height: "80vh" }}>
      <Helmet>
        <title key="update">Đang Cập Nhật | Habako M&E</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 style={{ fontSize: "50px" }}>🚧</h1>
      <h2>TÍNH NĂNG ĐANG PHÁT TRIỂN</h2>
      <p style={{ color: "#777", marginBottom: "20px" }}>
        Trang này hiện đang được Habako hoàn thiện nội dung. Vui lòng quay lại sau!
      </p>d
      <button 
        onClick={() => navigate("/")}
        style={{ padding: "10px 20px", cursor: "pointer", background: "#007bff", color: "#fff", border: "none", borderRadius: "5px" }}
      >
        Quay lại Trang Chủ
      </button>
    </div>
  );
};
export default ComingSoon